export default __webpack_public_path__ + "static/media/gallery_02.217ac51d.jpg";